import React from 'react';
export const getChildProps = (children)=>{
    if (typeof children !== 'function') return React.Children.only(children).props;
    return {};
};
export const normalizeTrigger = (trigger)=>{
    if (trigger === null) return [];
    if (!Array.isArray(trigger)) return [
        trigger
    ];
    return trigger;
};
export const normalizeDelay = (delay)=>{
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
};
